export enum CommunicationChannels {
  EMAIL = 'email',
  SMS = 'sms',
}

export interface HandleSmsInboundsInput {
  body: string;
  from: string;
  id: string;
  operator_id: string;
  received_at: string;
  to: string;
  type: string;
}
